import { connect } from 'react-redux';
import { login } from 'actions/staffs';

let _content = null;

const Login = (props) => {
  const { login, success } = props;
  const onLogin = (formData) => {
    login(formData);
  };

  success && localStorage.setItem('storeLoggedIn', JSON.stringify(true));

  return (
    _content &&
    _content({
      props,
      onLogin,
    })
  );
};

const mapStateToProps = (state) => {
  return {
    pending: state.staffs.pending,
    error: state.staffs.error,
    success: state.staffs.loginSuccess,
    staffs: state.auth.staffs,
    currentStore: state.stores.currentStore,
  };
};

const mapDispatchToProps = {
  login,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(Login);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/login/index.js